export default {
    projectKey: "Clave del proyecto",
    updatedBy: "Actualizado por",
    entityName: "Nombre de la entidad",
    entityId: "Id. de la entidad",
    preferenceKey: "Clave de preferencia",
    updatedOn: "Actualizado en",
    deviceId: "Id. del dispositivo",
    temperature3: "Temperatura 3",
    temperature1: "Temperatura 1",
    temperature2: "Temperatura 2",
    eventName: "Nombre del evento",
    vin: "Vin",
    serverTime: "Hora del servidor",
    longitude: "Longitud",
    sequenceNumber: "Número de secuencia",
    normalizedSpeed: "Velocidad normalizada",
    desiredStarterState: "Estado de arranque deseado",
    speedLimit: "Límite de velocidad",
    accountId: "Id. de la cuenta",
    republish: "Volver a publicar",
    driverId: "Id. del conductor",
    LastMessageTime: "Hora del último mensaje",
    region: "Región",
    useEcuSpeed: "Utilizar Ecu Speed",
    useEcuOcometer: "Utilizar Ecu Ocometer",
    distance: "Distancia",
    latitude: "Latitud",
    deviceLabel: "Etiqueta del dispositivo",
    ecuEngineOdometer: "Cuentakilómetros del motor Ecu",
    rawMessage: "Mensaje en bruto",
    starterDisabled: "Arranque Desactivado",
    unitType: "Tipo de unidad",
    ignitionStatus: "Estado del encendido",
    satelliteCount: "Conteo de satélites",
    unitId: "Id. de la unidad",
    starterSupported: "Apoyo al arranque",
    unitgroupname: "Nombre del grupo de unidades",
    unitgroup_id: "Id. de grupo de unidades",
    unitgroupcolor: "Color del grupo de unidades",
    zip: "Zip",
    address: "Dirección",
    state: "Estado",
    city: "Ciudad",
    formatted: "Formateado",
    messageSource: "Fuente del mensaje",
    datacenter: "Centro de datos",
    rowId: "Id. de fila",
    eventCode: "Código de evento",
    unitDiagnostic: "Diagnóstico de la unidad",
    desiredStarterUpdated: "Deseo de inicio Actualizado",
    unitTime: "Tiempo de la unidad",
    configJSON: "Config JSON",
    severity: "Severidad",
    assignmentsCount: "Conteo de asignaciones",
    subscribersCount: "Conteo de suscriptores",
    type: "Tipo",
    createdOn: "Creado en",
    triggerCount: "Conteo de activaciones",
    createdBy: "Creado por",
    name: "Nombre",
    currentTab: "Ficha actual",
    defaultDateInfo: "Información de la fecha por defecto",
    companyId: "Id. de la empresa",
    fileIndex: "Índice de archivos",
    generatedAt: "Generado en",
    jsonPath: "Ruta Json",
    changedAt: "Cambiado en",
    generatedFile: "Archivo generado",
    alertBefore: "Alerta anterior",
    contactId: "Id. de contacto",
    alert: "Alerta",
    alertAfter: "Alerta suguiente",
    lastMaintenanceDate: "Última fecha de mantenimiento",
    notes: "Notas",
    completed: "Completado",
    estimatedCost: "Coste estimado",
    lastMaintenanceOdometer: "Último mantenimiento Cuentakilómetros",
    nextServiceDate: "Próxima fecha de servicio",
    fileIds: "Ids de los archivos",
    unitLabel: "Etiqueta de la unidad",
    serviceId: "Id. de servicio",
    status: "Estado",
    isGrouping: "Es Agrupación",
    year: "Año",
    ecuVin: "Ecu Vin",
    model: "Modelo",
    landmark_id: "Id. del punto de referencia",
    driverName: "Nombre del conductor",
    deviceNote: "Nota del dispositivo",
    sourceStack: "Fuente de la pila",
    landmarkname: "Nombre del punto de referencia",
    make: "Make",
    landmarkgroup_id: "Landmark Group Id",
    placeId: "Id. del lugar",
    landmarkName: "Nombre del punto de referencia",
    change_details_title: "Cambio",
    projectId: "Proyecto",
    description: "Descripción",
    crmId: "Id. de Salesforce",
    Timezone: "Zona horaria",
    dealerId: "Id. del distribuidor",
    roleId: "Id. del rol",
    language: "Idioma",
    res: "Respuesta",
    method: "Metodo",
    action: "Acción",
    username: "Usuario",
    source: "Fuente",
    module: "Modulo",
    platform: "Plataforma",
    ipAddress: "Dirección IP",
    moduleId: "Id. del módulo",
    isDefault: "Es por defecto",
    isCustom: "Está personalizado",
    tripID: "ID del viaje",
    notificationType: "Tipo de notificación",
    linkedDeviceId: "Id de dispositivo emparejado",
    troubleshooting: "Solución de problemas",
    changeTime: "Cambiar la hora",
    accumulatedDistance: "Distancia acumulada",
    currentStatus: "Estado actual",
    sn: "SN",
    vehicleID: "ID del vehículo",
    previousStatus: "Estado anterior",
    url: "Url",
    units: "Unidades",
    iot_rule_source: "Fuente de la regla IOT",
    address: "Dirección",
    deviceData: "Datos del dispositivo",
    rawMessage: "Mensaje en bruto",
    speedLimitRequest: "Solicitud de límite de velocidad",

    field: "Campo",
    parentId: "Identificación de los padres",
    categoryName: "Nombre de la categoría",
    dataResultFilter: "Filtro de resultados de datos",
    timeframeName: "Nombre de la zona horaria",
    timeZone: "Zona horaria",
    order: "Orden",
    fileFormat: "Formato de archivo",
    orientation: "Orientación",
    column: "Orientación",
    header: "Encabezado",
    folderName: "Nombre de la carpeta",
    filePrefixName: "Nombre de prefijo de archivo",
    culture: "Cultura",
    sendByEmail: "Enviar por correo electrónico",
    reportName: "Nombre del Reporte",
    UIParams: "Parámetros de IU",
    delayed: "Demorada",
    code: "Código",

    clipID: "ID del Clip",
    createdByUser: "Creado por el usuario",
    startDate: "Fecha de Inicio",
    thumbnailUrl: "Url de la miniatura",
    endDate: "Fecha Final",
    transactionId: "Id de transacción",
    errorMsg: "Mensaje de error",
    gpsTime: "Hora del GPS",
    authId: "Id. de Autenticación",
    driver: "Conductor",
    compdata: "Datos comp",
    unit: "Unidad"
};